export default "__VITE_ASSET__4f10d88f__"